/**
 * The query keys shared between the reads in this folder and the cache writes
 * in `devices-cache`.
 *
 * They live here rather than beside the query that owns each one because the
 * cache writes cross between them — updating one device touches the device and
 * the devices list — and importing a key from the query module directly would
 * close an import cycle and leave one side `undefined` at module init.
 */

// A single device, keyed `[FETCH_DEVICE_QUERY_KEY, deviceId]`. Seeded by the
// devices list so opening a device from the list needs no second request.
export const FETCH_DEVICE_QUERY_KEY = 'fetchDevice';

// Every device the caller can see, across companies. Read once at app start
// and handed to `DevicesProvider`, which scopes it to the current company.
export const FETCH_DEVICES_QUERY_KEY = 'fetchDevices';

// The status of a device test call/SMS, keyed
// `[FETCH_DEVICE_TEST_STATUS_QUERY_KEY, deviceId, statusId]`. The read itself
// polls on an interval rather than through React Query, so nothing is cached
// under this key today; it is here so a caller that has to drop the status can
// name the same key the read will use.
export const FETCH_DEVICE_TEST_STATUS_QUERY_KEY = 'fetchDeviceTestStatus';

// A single beacon, keyed `[FETCH_BEACON_QUERY_KEY, beaconId]`. Seeded by the
// beacons list.
export const FETCH_BEACON_QUERY_KEY = 'fetchBeacon';

// A company's beacons, keyed `[FETCH_BEACONS_QUERY_KEY, companyId]`.
export const FETCH_BEACONS_QUERY_KEY = 'fetchBeacons';
